/*
  Copies every form on the site to the Vortex webhook (/api/form), which emails it to
  team@vortexrugby.com and design@vortexrugby.com. Shopify still handles the form as normal;
  this only sends a copy alongside. Set the webhook in Theme settings > Form notifications.
  The team order form is left out: it already sends the full order to the webhook itself.
  Scripts that sign people up without a form (play-to-win, the kit designer) call
  window.vortexForms.send(name, fields).
*/
(() => {
  const base = (document.documentElement.dataset.formsWebhook || '').replace(/\/+$/, '');
  const url = base ? `${base}/api/form` : '';

  const send = (form, fields) => {
    if (!url) return false;
    const body = JSON.stringify({ form, page: window.location.href, submittedAt: new Date().toISOString(), fields });
    // sendBeacon survives the page navigating away after a normal form post
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return true;
    } catch (e) { /* fall through */ }
    try { fetch(url, { method: 'POST', body, headers: { 'Content-Type': 'text/plain' }, keepalive: true }).catch(() => {}); } catch (e) { /* best effort */ }
    return true;
  };

  const nameOf = (form) => {
    const type = (form.querySelector('[name="form_type"]') || {}).value || '';
    if (form.dataset.formName) return form.dataset.formName;
    if (type === 'customer') return 'Newsletter sign-up';
    if (type === 'contact') return (form.querySelector('[name="contact[Enquiry]"]') || {}).value || 'Contact form';
    return form.getAttribute('aria-label') || form.id || 'Website form';
  };

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-kit-form]') && document.querySelector('[data-order][data-webhook]:not([data-webhook=""])')) return;
    if (form.matches('[role="search"], [action*="/search"], [action*="/cart"], [action*="/account/login"], [action*="/account/recover"]')) return;
    if (/\/(cart|checkout|account\/login)/.test(form.getAttribute('action') || '')) return;
    const fields = {};
    new FormData(form).forEach((v, k) => {
      if (typeof v !== 'string' || /password/i.test(k)) return;
      fields[k] = fields[k] ? `${fields[k]}, ${v}` : v;
    });
    const trap = form.querySelector('[data-order-trap]');
    if (trap && trap.value) return;
    send(nameOf(form), fields);
  }, true);

  window.vortexForms = { send };
})();
